export default "__VITE_ASSET__CcNWvize__"